import {Grid} from "@mui/material";
import * as React from "react";
import {DropCalendar} from "./DropCalendar";

function BakeryCalendar(props) {

  return (
          <div>
            <Grid container marginTop={5} justifyContent={'center'}>
              <DropCalendar/>
            </Grid>
          </div>
  )
}

export {BakeryCalendar}